<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h4>RSS-Feeds</h4>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="example-container mat-elevation-z2">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index;" class="mat-column w5">
                            {{i+1}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="image">
                        <th mat-header-cell *matHeaderCellDef>
                            Standard-Bild
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column w20">
                            <img class="width75" src="{{element.defaultImage.url}}" alt="">
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="feedUri">
                        <th mat-header-cell *matHeaderCellDef>
                            Quelle
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column w50" style="padding-right: 25px;">
                            {{element.feedUri}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>
                            Typ
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column w50">
                            <mat-chip-set>
                                <mat-chip class="primaryChip" selected *ngIf="element.type == 'NEWS' ">
                                    {{element.type | translateState}}
                                </mat-chip>
                                <mat-chip class="accentChip" selected *ngIf="element.type == 'APPOINTMENT' ">
                                    {{element.type | translateState}}
                                </mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef>
                            Aktion
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                color="accent" >
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item [routerLink]="['edit', element.publicId]">
                                    <span>Bearbeiten</span>
                                </button>
                                <button mat-menu-item (click)="refreshRssFeed(element)">
                                    <span>Aktualisieren</span>
                                </button>                   
                                <button mat-menu-item (click)="deleteRssFeeds(element.publicId)">
                                    <span>Löschen</span>
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
                </table>
                <span *ngIf="dataSource?.data.length === 0" class="emptyTableState  mat-elevation-z2">Keine passenden
                    Einträge
                    gefunden...</span>

            </div>
            <button class="fabAddBtnBottomRight" mat-fab color="accent" [routerLink]="['add']">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <mat-paginator [length]="page.totalElements" class="paginator-centered" [pageSize]="page.size" [pageIndex]="page.number"
    (page)="loadPage($event)" [pageSizeOptions]="[6, 12, 24, 36]" *ngIf="page">
</mat-paginator>
        </div>
    </div>
</div>
